import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export const NewsRelease = () => {
  const { t } = useLang();

  return (
    <section className="bg-brand-cream py-24 md:py-32" data-testid="news-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="col-span-12 md:col-span-4"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="block w-8 h-px bg-brand-red" />
              <span className="font-sans text-[11px] tracking-[0.3em] uppercase text-brand-red">
                {t.news.label}
              </span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-brand-ink leading-[1.05]">
              {t.news.heading}
              <span className="italic text-brand-red">.</span>
            </h2>
            <a
              href="#contact"
              className="mt-8 inline-flex items-center gap-2 font-sans text-sm tracking-wider text-brand-ink hover:text-brand-red transition-colors group"
              data-testid="news-view-all"
            >
              <span className="border-b border-brand-ink group-hover:border-brand-red pb-1">{t.news.viewAll}</span>
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
          </motion.div>

          <div className="col-span-12 md:col-span-8 md:pl-12">
            <ul className="divide-y divide-brand-ink/10 border-t border-brand-ink/10">
              {t.news.items.map((item, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                  className="group py-6 flex flex-col md:flex-row md:items-center gap-3 md:gap-8 cursor-pointer hover:px-3 transition-all duration-500"
                  data-testid={`news-item-${i}`}
                >
                  <span className="font-sans text-xs tracking-[0.2em] text-brand-muted shrink-0 w-24">
                    {item.date}
                  </span>
                  <span className="inline-flex items-center justify-center px-3 py-1 border border-brand-yellow text-brand-yellow text-[10px] tracking-[0.2em] uppercase shrink-0 w-fit">
                    {item.category}
                  </span>
                  <span className="font-serif text-lg md:text-xl text-brand-ink flex-1 group-hover:text-brand-red transition-colors">
                    {item.title}
                  </span>
                  <ArrowUpRight className="hidden md:block w-4 h-4 text-brand-ink/30 group-hover:text-brand-red group-hover:translate-x-1 transition-all" />
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
